import { default as isCitvoiceMeasure } from '../isCitvoiceMeasure';

export default (state, level) => state.fullListOfMeasures.filter((n) => n.lvl == level && isCitvoiceMeasure(state, n.s_id));
